export default "__VITE_PUBLIC_ASSET__f01ab28d__"